import * as actionTypes from '../actions/actionTypes';

import updateObject from '../../util/updateObject';

const initialState = {
    orders: null, 
    loading: false, 
    error: null, 
    selectedOrderStops: null, 
    selectedOrderPay: null
};

const getOrdersStart = (state, action) => {
    return updateObject(state, { loading: true, error: null, orders: null, selectedOrderStops: null, selectedOrderPay: null });
};

const getOrdersSuccess = (state, action) => {
    return updateObject(state, { loading: false, error: null, orders: action.orders });
};

const getOrdersFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error, orders: null });
};

const getOrderStart = (state, action) => {
    return updateObject(state, { loading: true, error: null, selectedOrderStops: null, selectedOrderPay: null });
};

const getOrderSuccess = (state, action) => {
    return updateObject(state, { loading: false, error: null, selectedOrderStops: action.stops, selectedOrderPay: action.pay });
};

const getOrderFail = (state, action) => {
    return updateObject(state, { loading: false, error: action.error, selectedOrderStops: null, selectedOrderPay: null });
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.ORDER_GET_ORDERS_FROM_SERVER_START: return getOrdersStart(state, action);
        case actionTypes.ORDER_GET_ORDERS_FROM_SERVER_SUCCESS: return getOrdersSuccess(state, action);
        case actionTypes.ORDER_GET_ORDERS_FROM_SERVER_FAIL: return getOrdersFail(state, action);

        case actionTypes.ORDER_GET_ORDER_FROM_SERVER_START: return getOrderStart(state, action);
        case actionTypes.ORDER_GET_ORDER_FROM_SERVER_SUCCESS: return getOrderSuccess(state, action);
        case actionTypes.ORDER_GET_ORDER_FROM_SERVER_FAIL: return getOrderFail(state, action);

        default: return state;
    }
}

export default reducer;